import { authChangePerspective } from "auth";
import React, { FC, PropsWithChildren } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "redux/state";
import { SiteHeader } from "../components/SiteHeader";

export interface SiteHeaderContainerProps { }

export const SiteHeaderContainer: FC<PropsWithChildren<SiteHeaderContainerProps>> = props => {
    const state = useSelector<State, State>(state => state);

    const { asUser } = state.auth;

    const dispatch = useDispatch();

    function onChangePerspective() {
        // disables asUser view
        dispatch(authChangePerspective(false));
    }

    return (
        <SiteHeader
            asUser={asUser}
            user={state.auth.profile}
            onChangePerspective={onChangePerspective}
        >
            {props.children}
        </SiteHeader>
    );
};
